import { updateScheduledDaily } from "../repository/scheduled.repo";

export const UpdateScheduledDaily = async (data) => {
  try {
    const resp = await updateScheduledDaily(data);
    return resp.data;
  } catch (error) {
    return error.response.data;
  }
};
